/** Local calendar YYYY-MM-DD. */
export function parseIsoDate(value?: string): Date | null {
  if (!value || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
  const [y, m, d] = value.split('-').map((x) => Number.parseInt(x, 10));
  const dt = new Date(y, m - 1, d);
  if (dt.getFullYear() !== y || dt.getMonth() !== m - 1 || dt.getDate() !== d) return null;
  return dt;
}

export function toIsoDate(dt: Date): string {
  const y = dt.getFullYear();
  const m = `${dt.getMonth() + 1}`.padStart(2, '0');
  const d = `${dt.getDate()}`.padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function formatDateFr(dt: Date): string {
  const d = `${dt.getDate()}`.padStart(2, '0');
  const m = `${dt.getMonth() + 1}`.padStart(2, '0');
  return `${d}/${m}/${dt.getFullYear()}`;
}

/** Digit mask for `JJ/MM/AAAA`. */
export function maskFrDateInput(raw: string): string {
  const digits = raw.replace(/\D/g, '').slice(0, 8);
  const dd = digits.slice(0, 2);
  const mm = digits.slice(2, 4);
  const yyyy = digits.slice(4, 8);
  if (digits.length <= 2) return dd;
  if (digits.length <= 4) return `${dd}/${mm}`;
  return `${dd}/${mm}/${yyyy}`;
}

/** Accept `JJ/MM/AAAA`, `J/M/AA`, ISO `YYYY-MM-DD`. Two-digit year maps to 20xx. */
export function parseFlexibleDate(raw: string): Date | null {
  const t = raw.trim();
  if (!t) return null;
  const iso = parseIsoDate(t);
  if (iso) return iso;
  const m = t.match(/^(\d{1,2})[/.\-](\d{1,2})[/.\-](\d{2}|\d{4})$/);
  if (!m) return null;
  const day = Number.parseInt(m[1]!, 10);
  const month = Number.parseInt(m[2]!, 10);
  let year = Number.parseInt(m[3]!, 10);
  if (year < 100) year += 2000;
  const dt = new Date(year, month - 1, day);
  if (dt.getFullYear() !== year || dt.getMonth() !== month - 1 || dt.getDate() !== day) return null;
  return dt;
}
